"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleCell = exports.PaddedDoubleContentCell = exports.PaddedContentCell = exports.MonogramCell = exports.Monogram = exports.DoubleCell = exports.DateCell = exports.Cells = exports.Cell = exports.BasicSingleCell = exports.BasicDoubleCell = void 0;
var React = _interopRequireWildcard(require("react"));
var _formatDistance = _interopRequireDefault(require("date-fns/formatDistance"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _classify = require("../../utils/classify");
var _makeClassNameComponent = require("../../utils/makeClassNameComponent");
var _Avatar = require("../Avatar");
var _Text = require("../Text");
var _TableModule = _interopRequireDefault(require("./Table.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // $FlowIssue[nonstrict-import] date-fns
// $FlowFixMe[untyped-import]
// $FlowIssue[nonstrict-import] date-fns
// $FlowFixMe[untyped-import]
const Cells = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: (0, _classify.classify)(_TableModule.default.row, className)
  }, rest), children);
};
exports.Cells = Cells;
const Cell = _ref2 => {
  let {
    children,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.classify)(_TableModule.default.cell, className)
  }, children);
};
exports.Cell = Cell;
const BasicSingleCell = exports.BasicSingleCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.defaultSingleCell, 'td');
const BasicDoubleCell = exports.BasicDoubleCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.defaultDoubleCell, 'td');
const PaddedContentCell = exports.PaddedContentCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.singleContentCell, 'td');
const PaddedDoubleContentCell = exports.PaddedDoubleContentCell = (0, _makeClassNameComponent.makeClassNameComponent)(_TableModule.default.doubleContentCell, 'td');
const SingleCell = _ref3 => {
  let {
    title,
    className
  } = _ref3;
  return /*#__PURE__*/React.createElement(PaddedContentCell, {
    className: className
  }, /*#__PURE__*/React.createElement(_Text.BodyMedium, {
    className: _TableModule.default.paddedTitleBlock
  }, title));
};
exports.SingleCell = SingleCell;
const DoubleCell = _ref4 => {
  let {
    title,
    subtitle,
    className
  } = _ref4;
  return /*#__PURE__*/React.createElement(PaddedDoubleContentCell, {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: _TableModule.default.paddedTitleBlock
  }, /*#__PURE__*/React.createElement(_Text.BodyMedium, {
    className: _TableModule.default.doubleTitle
  }, title), /*#__PURE__*/React.createElement(_Text.BodySmall, {
    color: _Text.TEXT_COLORS.tertiary,
    className: _TableModule.default.doubleSubtitle
  }, subtitle ?? '')));
};
exports.DoubleCell = DoubleCell;
const DateCell = _ref5 => {
  let {
    date,
    className
  } = _ref5;
  const parsedDate = typeof date === 'object' ? date : (0, _parseISO.default)(date);
  return /*#__PURE__*/React.createElement(DoubleCell, {
    title: `${parsedDate.getMonth() + 1} / ${parsedDate.getDate() + 1} / ${parsedDate.getFullYear()}`,
    subtitle: `${(0, _formatDistance.default)(parsedDate, new Date())} ago`,
    className: className
  });
};
exports.DateCell = DateCell;
const Monogram = _ref6 => {
  let {
    initials
  } = _ref6;
  return /*#__PURE__*/React.createElement(_Avatar.Avatar, {
    size: "small",
    text: initials
  });
};
exports.Monogram = Monogram;
const MonogramCell = _ref7 => {
  let {
    initials,
    className
  } = _ref7;
  return /*#__PURE__*/React.createElement(PaddedContentCell, {
    className: className
  }, /*#__PURE__*/React.createElement(Monogram, {
    initials: initials
  }));
};
exports.MonogramCell = MonogramCell;